import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Nav } from "@/components/td/Nav";
import { Footer } from "@/components/td/Footer";
import { LEGAL } from "@/data/legal";

export default function Legal({ page }) {
  const doc = LEGAL[page];

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${doc.title} · TAANDEM`;
    return () => {
      document.title = "TAANDEM · Conectamos personas, marcas y proyectos";
    };
  }, [doc]);

  return (
    <div className="td">
      <Nav solid />
      <main data-testid={`legal-${page}`}>
        <section className="dk" style={{ padding: "clamp(120px,14vw,180px) 0 clamp(40px,5vw,64px)" }}>
          <div className="wrap">
            <Link to="/" className="lb" style={{ color: "var(--or)" }}>← Inicio</Link>
            <p className="lb" style={{ marginTop: 32 }}>{doc.label}</p>
            <h1 className="h h2" style={{ marginTop: 20 }}>{doc.title}</h1>
            <p className="lb mut" style={{ marginTop: 24 }}>Última actualización: {doc.updated}</p>
            {doc.intro && <p className="lead" style={{ marginTop: 24, maxWidth: 820 }}>{doc.intro}</p>}
          </div>
        </section>

        <section className="sec bn-sec">
          <div className="wrap" style={{ maxWidth: 900 }}>
            {doc.sections.map((s, i) => (
              <div key={s.h} style={{ padding: "clamp(28px,3vw,44px) 0", borderTop: "2px solid currentColor" }}>
                <p className="lb" style={{ color: "var(--bl)" }}>{String(i + 1).padStart(2, "0")}</p>
                <h2 className="h h3" style={{ marginTop: 12 }}>{s.h}</h2>
                {(s.p || []).map((t, j) => (
                  <p key={j} style={{ marginTop: 16, lineHeight: 1.6, fontSize: 17 }}>{t}</p>
                ))}
                {s.list && (
                  <ul style={{ marginTop: 16, paddingLeft: 20, lineHeight: 1.6, fontSize: 17 }}>
                    {s.list.map((t, j) => <li key={j} style={{ marginTop: 6 }}>{t}</li>)}
                  </ul>
                )}
                {(s.after || []).map((t, j) => (
                  <p key={j} style={{ marginTop: 16, lineHeight: 1.6, fontSize: 17 }}>{t}</p>
                ))}
              </div>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
